{
  "$id": "wealthlane://forms/grant-management",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../grant-management.domain.json",
  "properties": {
    "id": {
      "$ref": "module://grant-management#properties/id"
    },
    "planName": {
      "$ref": "module://grant-management#properties/planName",
      "widget": "label",
      "readOnly": true,
      "hiddenWhen": { "meta": "mode", "equals": "create" },
      "adapterProps": {
        "hideLabel": true,
        "variant": "h4"
      }
    },
    "uniquePlanNo": {
      "$ref": "module://grant-management#properties/uniquePlanNo",
      "hiddenWhen": { "meta": "mode", "equals": "create" },
      "adapterProps": {
        "hideLabel": true,
        "lozengeShape": "pill",
        "lozengeSize": "md"
      }
    },
    "grantName": {
      "$ref": "module://grant-management#properties/grantName",
      "required": true,
      "disabledWhen": {
        "allOf": [
          { "meta": "mode", "equals": "edit" },
          { "field": "isGrantInUse", "equals": true }
        ]
      }
    },
    "planId": {
      "$ref": "module://grant-management#properties/planId",
      "required": true,
      "actionId": "FETCH_PLAN_WITH_POOL_OPTIONS",
      "paramMap": {
        "includePlanId": "planId",
        "includePlanLabel": "planName"
      },
      "disabledWhen": {
        "allOf": [
          { "meta": "mode", "equals": "edit" },
          { "field": "isGrantInUse", "equals": true }
        ]
      }
    },
    "planTypeName": {
      "$ref": "module://grant-management#properties/planTypeName",
      "required": true,
      "actionId": "FETCH_GRANT_PLAN_TYPE_OPTIONS",
      "dependsOn": "planId",
      "paramMap": { "planId": "planId" },
      "disabledWhen": {
        "allOf": [
          { "meta": "mode", "equals": "edit" },
          { "field": "isGrantInUse", "equals": true }
        ]
      }
    },
    "planType": {
      "$ref": "module://grant-management#properties/planType"
    },
    "approvedDate": {
      "$ref": "module://grant-management#properties/approvedDate",
      "required": true,
      "adapterProps": {
        "tooltip": "This date represents board approval of the grant."
      },
      "disabledWhen": {
        "allOf": [
          { "meta": "mode", "equals": "edit" },
          { "field": "isGrantInUse", "equals": true }
        ]
      }
    },
    "approvalRequired": {
      "$ref": "module://grant-management#properties/approvalRequired",
      "disabledWhen": { "meta": "mode", "equals": "view" }
    },
    "poolId": {
      "$ref": "module://grant-management#properties/poolId",
      "required": true,
      "disabledWhen": { "meta": "mode", "equals": "view" }
    },
    "poolDisplayLabel": {
      "$ref": "module://grant-management#properties/poolDisplayLabel"
    },
    "acceptanceMethodId": {
      "$ref": "module://grant-management#properties/acceptanceMethodId",
      "required": true,
      "actionId": "FETCH_ACCEPTANCE_METHOD_OPTIONS",
      "disabledWhen": { "meta": "mode", "equals": "view" }
    },
    "acceptanceMethod": {
      "$ref": "module://grant-management#properties/acceptanceMethod"
    },
    "settlementTypeId": {
      "$ref": "module://grant-management#properties/settlementTypeId",
      "actionId": "FETCH_SETTLEMENT_TYPE_OPTIONS",
      "hiddenWhen": {
        "allOf": [
          { "field": "planType", "notEquals": "RSU" },
          { "field": "planType", "notEquals": "PSU" }
        ]
      },
      "clearOnHideWhen": true,
      "disabledWhen": { "meta": "mode", "equals": "view" }
    },
    "settlementTypeName": {
      "$ref": "module://grant-management#properties/settlementTypeName"
    },
    "performanceRuleName": {
      "$ref": "module://grant-management#properties/performanceRuleName",
      "actionId": "FETCH_AVAILABLE_PERFORMANCE_RULES",
      "dependsOn": "planTypeName",
      "paramMap": {
        "planTypeName": "planTypeName",
        "planType": "planType",
        "grantId": "id"
      },
      "hiddenWhen": { "field": "planType", "notEquals": "PSU" },
      "requiredWhen": { "field": "planType", "equals": "PSU" },
      "clearOnHideWhen": true,
      "disabledWhen": {
        "anyOf": [
          { "meta": "mode", "equals": "view" },
          {
            "allOf": [
              { "meta": "mode", "equals": "edit" },
              { "field": "isGrantInUse", "equals": true }
            ]
          }
        ]
      }
    },
    "performanceRuleId": {
      "$ref": "module://grant-management#properties/performanceRuleId"
    },
    "vestingTemplateName": {
      "$ref": "module://grant-management#properties/vestingTemplateName",
      "required": true,
      "actionId": "FETCH_GRANT_VESTING_OPTIONS",
      "disabledWhen": {
        "anyOf": [
          { "meta": "mode", "equals": "view" },
          {
            "allOf": [
              { "meta": "mode", "equals": "edit" },
              { "field": "isGrantInUse", "equals": true }
            ]
          }
        ]
      }
    },
    "grantAcceptanceTemplateId": {
      "$ref": "module://grant-management#properties/grantAcceptanceTemplateId",
      "actionId": "FETCH_GRANT_ACCEPTANCE_TEMPLATE_OPTIONS",
      "hiddenWhen": { "meta": "canViewGrantAcceptanceTemplate", "equals": false },
      "disabledWhen": { "meta": "mode", "equals": "view" }
    },
    "grantAgreementDocumentName": {
      "$ref": "module://grant-management#properties/grantAgreementDocumentName",
      "actionId": "FETCH_PLAN_GRANT_DOCUMENT_OPTIONS",
      "dependsOn": "planId",
      "paramMap": { "planId": "planId", "documentType": "$const:1" },
      "adapterProps": {
        "exclusiveDocumentType": 1,
        "exclusiveStoreClearActionId": "CLEAR_GRANT_DOCS_BY_TYPE"
      },
      "disabledWhen": {
        "anyOf": [
          { "meta": "mode", "equals": "view" },
          {
            "allOf": [
              { "meta": "mode", "equals": "edit" },
              { "field": "isGrantInUse", "equals": true }
            ]
          }
        ]
      }
    },
    "grantNoticeDocumentName": {
      "$ref": "module://grant-management#properties/grantNoticeDocumentName",
      "actionId": "FETCH_PLAN_GRANT_DOCUMENT_OPTIONS",
      "dependsOn": "planId",
      "paramMap": { "planId": "planId", "documentType": "$const:2" },
      "adapterProps": {
        "exclusiveDocumentType": 2,
        "exclusiveStoreClearActionId": "CLEAR_GRANT_DOCS_BY_TYPE"
      },
      "disabledWhen": {
        "anyOf": [
          { "meta": "mode", "equals": "view" },
          {
            "allOf": [
              { "meta": "mode", "equals": "edit" },
              { "field": "isGrantInUse", "equals": true }
            ]
          }
        ]
      }
    },
    "agreementStatement": {
      "$ref": "module://grant-management#properties/agreementStatement",
      "required": true,
      "disabledWhen": { "meta": "mode", "equals": "view" }
    },
    "agreementStatementStatusName": {
      "$ref": "module://grant-management#properties/agreementStatementStatusName",
      "required": true,
      "disabledWhen": { "meta": "mode", "equals": "view" }
    },
    "enableTermsConditionText": {
      "$ref": "module://grant-management#properties/enableTermsConditionText",
      "disabledWhen": { "meta": "mode", "equals": "view" },
      "adapterProps": {
        "reserveLabelSpace": false
      }
    },
    "termsAndConditionDocumentName": {
      "$ref": "module://grant-management#properties/termsAndConditionDocumentName",
      "actionId": "FETCH_PLAN_GRANT_DOCUMENT_OPTIONS",
      "dependsOn": "planId",
      "paramMap": { "planId": "planId", "documentType": "$const:3" },
      "adapterProps": {
        "exclusiveDocumentType": 3,
        "exclusiveStoreClearActionId": "CLEAR_GRANT_DOCS_BY_TYPE"
      },
      "hiddenWhen": { "field": "enableTermsConditionText", "equals": true },
      "clearOnHideWhen": true,
      "disabledWhen": { "meta": "mode", "equals": "view" }
    },
    "termsAndConditionTextName": {
      "$ref": "module://grant-management#properties/termsAndConditionTextName",
      "actionId": "FETCH_PLAN_GRANT_DOCUMENT_OPTIONS",
      "dependsOn": "planId",
      "paramMap": { "planId": "planId", "documentType": "$const:4" },
      "adapterProps": {
        "exclusiveDocumentType": 4,
        "exclusiveStoreClearActionId": "CLEAR_GRANT_DOCS_BY_TYPE"
      },
      "hiddenWhen": { "field": "enableTermsConditionText", "notEquals": true },
      "clearOnHideWhen": true,
      "disabledWhen": { "meta": "mode", "equals": "view" }
    },
    "isGrantInUse": {
      "$ref": "module://grant-management#properties/isGrantInUse"
    },
    "_originalApprovalRequired": {
      "$ref": "module://grant-management#properties/_originalApprovalRequired"
    },
    "planGrantDocuments": {
      "$ref": "module://grant-management#properties/planGrantDocuments"
    },
    "OPEN_VESTING_MODAL": {
      "$ref": "module://grant-management#properties/OPEN_VESTING_MODAL",
      "hiddenWhen": { "meta": "mode", "equals": "view" }
    },
    "OPEN_PERFORMANCE_RULES_MODAL": {
      "$ref": "module://grant-management#properties/OPEN_PERFORMANCE_RULES_MODAL",
      "hiddenWhen": {
        "anyOf": [
          { "field": "planType", "notEquals": "PSU" },
          { "meta": "mode", "equals": "view" }
        ]
      }
    },
    "VIEW_GRANT_PERFORMANCE_RULE": {
      "$ref": "module://grant-management#properties/VIEW_GRANT_PERFORMANCE_RULE",
      "label": "View rule",
      "variant": "link",
      "visibleInViewMode": true,
      "hiddenWhen": {
        "anyOf": [
          { "meta": "mode", "notEquals": "view" },
          { "field": "planType", "notEquals": "PSU" },
          { "field": "performanceRuleId", "isEmpty": true }
        ]
      }
    },
    "OPEN_GRANT_ACCEPTANCE_TEMPLATE_MODAL": {
      "$ref": "module://grant-management#properties/OPEN_GRANT_ACCEPTANCE_TEMPLATE_MODAL",
      "hiddenWhen": {
        "anyOf": [
          { "meta": "mode", "equals": "view" },
          { "meta": "canViewGrantAcceptanceTemplate", "equals": false }
        ]
      }
    },
    "OPEN_GRANT_AGREEMENT_MODAL": {
      "$ref": "module://grant-management#properties/OPEN_GRANT_AGREEMENT_MODAL",
      "hiddenWhen": { "meta": "mode", "equals": "view" },
      "disabledWhen": { "field": "isGrantInUse", "equals": true }
    },
    "OPEN_GRANT_NOTICE_MODAL": {
      "$ref": "module://grant-management#properties/OPEN_GRANT_NOTICE_MODAL",
      "hiddenWhen": { "meta": "mode", "equals": "view" },
      "disabledWhen": { "field": "isGrantInUse", "equals": true }
    },
    "OPEN_TERMS_CONDITIONS_DOC_MODAL": {
      "$ref": "module://grant-management#properties/OPEN_TERMS_CONDITIONS_DOC_MODAL",
      "hiddenWhen": {
        "anyOf": [
          { "meta": "mode", "equals": "view" },
          { "field": "enableTermsConditionText", "equals": true }
        ]
      }
    },
    "OPEN_TERMS_CONDITIONS_TEXT_MODAL": {
      "$ref": "module://grant-management#properties/OPEN_TERMS_CONDITIONS_TEXT_MODAL",
      "hiddenWhen": {
        "anyOf": [
          { "meta": "mode", "equals": "view" },
          { "field": "enableTermsConditionText", "notEquals": true }
        ]
      }
    },
    "grantAgreementDocs": {
      "$ref": "module://grant-management#properties/grantAgreementDocs",
      "adapterProps": {
        "storeKey": "GrantDocumentStore",
        "filterGroup": "Grant Agreement Document",
        "exclusiveDropdown": "grantAgreementDocumentName"
      }
    },
    "grantNoticeDocs": {
      "$ref": "module://grant-management#properties/grantNoticeDocs",
      "adapterProps": {
        "storeKey": "GrantDocumentStore",
        "filterGroup": "Grant Notice Document",
        "exclusiveDropdown": "grantNoticeDocumentName"
      }
    },
    "termsConditionDocDocs": {
      "$ref": "module://grant-management#properties/termsConditionDocDocs",
      "hiddenWhen": { "field": "enableTermsConditionText", "equals": true },
      "clearOnHideWhen": true,
      "adapterProps": {
        "storeKey": "GrantDocumentStore",
        "filterGroup": "Terms And Condition Document",
        "exclusiveDropdown": "termsAndConditionDocumentName",
        "exclusiveDocumentType": 3,
        "exclusiveStoreClearActionId": "CLEAR_GRANT_DOCS_BY_TYPE"
      }
    },
    "termsConditionTextDocs": {
      "$ref": "module://grant-management#properties/termsConditionTextDocs",
      "hiddenWhen": { "field": "enableTermsConditionText", "notEquals": true },
      "clearOnHideWhen": true,
      "adapterProps": {
        "storeKey": "GrantDocumentStore",
        "filterGroup": "Terms And Condition Text",
        "exclusiveDropdown": "termsAndConditionTextName",
        "exclusiveDocumentType": 4,
        "exclusiveStoreClearActionId": "CLEAR_GRANT_DOCS_BY_TYPE"
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_GRANT_MANAGEMENT",
      "refreshEntities": ["Grant"],
      "invalidateQueries": ["getGrantList", "getPlanManagementList"]
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "submit": {
          "successMessage": "Grant added."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_GRANT_MANAGEMENT_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "successMessage": "Grant edited."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_GRANT_MANAGEMENT_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
